import { render, staticRenderFns } from "./GenerateVoucher.vue?vue&type=template&id=267d2bf5&"
import script from "./GenerateVoucher.vue?vue&type=script&lang=js&"
export * from "./GenerateVoucher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports